import { Result } from 'antd'
import { Title } from 'components'

import { useStore } from '@sar/framework/hooks'
import { useMatch } from 'react-router'

export default (Target: React.FC<any>) => function (props: any) {
  const isunderwork = R.call(
    R.cond([
      [() => useMatch(`/recycling/list`) != null, R.T],
      [() => useMatch(`/price/list/template`) != null, R.T],
    ])
  )

  if (!isunderwork) {
    return <Target {...props} />
  }

  return <div className='flex items-center justify-center bg-white m-4'>
    <Result
      status='403'
      title='敬请期待'
      subTitle='这个功能目前还在开发中。'
    />
  </div>
}
